import { render, staticRenderFns } from "./OrgStructureIndex.vue?vue&type=template&id=2241a271&scoped=true&"
import script from "./OrgStructureIndex.vue?vue&type=script&lang=ts&"
export * from "./OrgStructureIndex.vue?vue&type=script&lang=ts&"
import style0 from "./OrgStructureIndex.vue?vue&type=style&index=0&id=2241a271&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2241a271",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VContent } from 'vuetify/lib/components/VContent';
installComponents(component, {VBtn,VCard,VContent})
